import React, { useEffect, useState } from "react";
import ListDataRecAgency from "./ListDataRecAgency";
import axios from "../../../../../../Global/axios";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import { useParams } from "react-router-dom";
import AddNewRecAgency from "./AddNewRecAgency";

export default function RecAgency() {
  const { projectId } = useParams();
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [agencyData, setAgencyData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchAgency = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/dashboard/project-recruitment-agency/${projectId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status == 200) {
        setLoading(false);
        setAgencyData(res.data.data);
      }
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
      setLoading(false);
    }
  };
  const [showAddNewAgencyPopUp, setShowAddNewAgencyPopUp] = useState(false);

  useEffect(() => {
    fetchAgency();
  }, []);
  return (
    <div className="w-full p-2">
      <ListDataRecAgency
        setAgencyData={setAgencyData}
        titles={[
          "S.NO.",
          "REC. AGENCY NAME",
          "REC. AGENCY JOB ENQ NO",
          "NATIONALITY",
          "JOB ENQUIRY STATUS",
          "JOB ENQUIRY ACCEPTANCE STATUS",
          "JOB ORDER STATUS",
          "ACTION",
        ]}
        recAgencyData={agencyData}
        loading={loading}
        setShowAddNewAgencyPopUp={setShowAddNewAgencyPopUp}
      />
      {showAddNewAgencyPopUp && (
        <AddNewRecAgency
          onToggle={() => setShowAddNewAgencyPopUp(!showAddNewAgencyPopUp)}
          recAgencyData={agencyData}
          setAgencyData={setAgencyData}
        />
      )}
    </div>
  );
}
